@use "../../scss/abstracts/utilities";

:host {
  display: block;
  width: 2.5rem;
  height: 2.5rem;
  font-size: utilities.toRem(24px);
}

.tag-circle {
  display: block;
  width: 100%;
  height: 100%;
  background: var(--sh_accent-primary);
  border-radius: 50%;
  color: var(--sh_fg-primary-inverted);
  font-family: "Russo One", var(--sh_base-font-family);
  line-height: 1.667;
  text-align: center;
  text-decoration: none;
}
